import APIKit from "../Allapis/Apikit/apikit";

export const getAllCardRequests = async (id) => {
    try {
      const url =  `/cards/iCards`;
      const res = await APIKit.get(url);  
      return res.data;
    } catch (e) {
      console.log(e);
    }
};

export const activateCard = async (id, values) => {
    try {
      const url =  `/cards/inventory`;
      const res = await APIKit.post(url, values);  
      return res.data;
    } catch (e) {
      return e.response ? e.response.data : e;
    }
};